

<div *ngIf="loaderService.isLoading$ | async">
    <div class="loader">
    </div>
</div>